/**
 * The shift runs 10:00 PM → 6:00 AM. Game logic works in "shift minutes"
 * (0 … 480) and these helpers translate to wall-clock labels.
 */
export const SHIFT_START_HOUR = 22;
export const SHIFT_MINUTES = 8 * 60;
export const SHIFT_HOURS = 8;

/** Shift minutes for a wall-clock time. `at(3, 33)` → 333. */
export function at(hour24: number, minute = 0): number {
  const minutesOfDay = hour24 * 60 + minute;
  const start = SHIFT_START_HOUR * 60;
  return (minutesOfDay - start + 24 * 60) % (24 * 60);
}

/** Wall-clock label such as "2:47 AM" for a number of shift minutes. */
export function clockLabel(shiftMinutes: number): string {
  const total = (SHIFT_START_HOUR * 60 + Math.floor(shiftMinutes)) % (24 * 60);
  const h24 = Math.floor(total / 60);
  const mm = total % 60;
  const suffix = h24 >= 12 ? 'PM' : 'AM';
  const h12 = h24 % 12 === 0 ? 12 : h24 % 12;
  return `${h12}:${mm.toString().padStart(2, '0')} ${suffix}`;
}

/** 0 = the 10 PM hour … 7 = the 5 AM hour. */
export function shiftHour(shiftMinutes: number): number {
  return Math.max(0, Math.min(SHIFT_HOURS - 1, Math.floor(shiftMinutes / 60)));
}

/** Short label for an hour index: 0 → "10P", 4 → "2A". */
export function hourLabel(hourIndex: number): string {
  const h24 = (SHIFT_START_HOUR + hourIndex) % 24;
  const h12 = h24 % 12 === 0 ? 12 : h24 % 12;
  return `${h12}${h24 >= 12 ? 'P' : 'A'}`;
}
